<template>
    <div>
        <div
            v-if="!isDesktop"
            class="relative mx-auto w-full max-w-lg select-none"
            @touchstart.passive="onTouchStart"
            @touchend.passive="onTouchEnd"
        >
            <div
                class="aspect-banner overflow-hidden rounded-2xl bg-stack-text shadow-lg"
            >
                <component
                    :is="activeItem && activeItem.href ? 'a' : 'div'"
                    v-if="activeItem"
                    v-bind="linkAttrs(activeItem)"
                    :aria-label="activeItem.title"
                    class="relative block h-full w-full"
                    @click="onClick"
                >
                    <img
                        v-if="activeItem.imageUrl"
                        :src="activeItem.imageUrl"
                        :alt="activeItem.imageAlt"
                        class="h-full w-full object-cover"
                    />
                    <div v-else class="h-full w-full">
                        <slot name="placeholder" :item="activeItem"></slot>
                    </div>
                </component>
            </div>

            <button
                v-if="items.length > 1"
                type="button"
                class="absolute left-2 top-1/2 -translate-y-1/2 transform rounded-full bg-carousel-control p-2 shadow"
                aria-label="Anterior"
                @click="prevItem"
            >
                <svg
                    class="h-4 w-4 text-gray-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 19l-7-7 7-7"
                    />
                </svg>
            </button>
            <button
                v-if="items.length > 1"
                type="button"
                class="absolute right-2 top-1/2 -translate-y-1/2 transform rounded-full bg-carousel-control p-2 shadow"
                aria-label="Siguiente"
                @click="nextItem"
            >
                <svg
                    class="h-4 w-4 text-gray-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                    />
                </svg>
            </button>

            <span
                v-if="items.length > 1"
                class="absolute right-2 top-2 rounded-full bg-stack-primary px-2 py-1 text-xs text-white"
            >
                {{ activeIndex + 1 }}/{{ items.length }}
            </span>

            <div v-if="items.length > 1" class="mt-3 flex justify-center gap-1">
                <button
                    v-for="(item, i) in items"
                    :key="`dot-${item.key}`"
                    type="button"
                    class="h-2 rounded-full transition-all duration-200"
                    :class="
                        i === activeIndex
                            ? 'w-4 bg-stack-emphasis'
                            : 'w-2 bg-stack-text'
                    "
                    :aria-label="`Ir a ${item.title}`"
                    @click="activeIndex = i"
                ></button>
            </div>
        </div>

        <div v-else class="grid grid-cols-2 gap-4">
            <component
                :is="item.href ? 'a' : 'div'"
                v-for="(item, index) in items"
                :key="item.key"
                v-bind="linkAttrs(item)"
                :aria-label="item.title"
                class="group relative overflow-hidden rounded-2xl bg-stack-text no-underline shadow-lg"
                :class="[
                    shouldSpanFull(index)
                        ? 'col-span-2 mx-auto aspect-banner w-full max-w-lg'
                        : 'col-span-1 h-56',
                    item.href ? 'cursor-pointer' : ''
                ]"
                @click="onClick"
            >
                <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.imageAlt"
                    class="absolute inset-0 h-full w-full transform object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div v-else class="absolute inset-0">
                    <slot name="placeholder" :item="item"></slot>
                </div>
            </component>
        </div>
    </div>
</template>

<script>
export default {
    name: "SliderV10",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    data: () => ({
        activeIndex: 0,
        touchStartX: 0
    }),
    computed: {
        activeItem() {
            return this.items[this.activeIndex];
        }
    },
    watch: {
        items() {
            this.activeIndex = 0;
        }
    },
    methods: {
        shouldSpanFull(index) {
            if (index === 0) return true;
            const remaining = this.items.length - 1;
            return index === this.items.length - 1 && remaining % 2 !== 0;
        },
        prevItem() {
            this.activeIndex =
                this.activeIndex > 0
                    ? this.activeIndex - 1
                    : this.items.length - 1;
        },
        nextItem() {
            this.activeIndex =
                this.activeIndex < this.items.length - 1
                    ? this.activeIndex + 1
                    : 0;
        },
        onTouchStart(event) {
            this.touchStartX = event.changedTouches[0].clientX;
        },
        onTouchEnd(event) {
            const delta = event.changedTouches[0].clientX - this.touchStartX;
            if (Math.abs(delta) < 50) return;
            if (delta < 0) this.nextItem();
            else this.prevItem();
        },
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
